/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Active_Orders_HintInputs */

const en_metric_active_orders_hint = /** @type {(inputs: Metric_Active_Orders_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders in pipeline`)
};

const es_metric_active_orders_hint = /** @type {(inputs: Metric_Active_Orders_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pedidos en flujo`)
};

/**
* | output |
* | --- |
* | "Orders in pipeline" |
*
* @param {Metric_Active_Orders_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const metric_active_orders_hint = /** @type {((inputs?: Metric_Active_Orders_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Active_Orders_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_metric_active_orders_hint(inputs)
	return es_metric_active_orders_hint(inputs)
});